<script lang="ts">
    import {createEventDispatcher, onMount} from 'svelte';
    import {slide} from 'svelte/transition';

    const dispatch = createEventDispatcher();

    export let dismissible: boolean = false;
    export let className: string = '';

    onMount(() => {
        dispatch('appear');
        return () => dispatch('disappear');
    });

    function close() {
        dispatch('close');
    }
</script>

<aside transition:slide|local class={className}>
{#if dismissible}
    <button on:click|preventDefault={close}></button>
{/if}
    <main><slot /></main>
</aside>
